import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Pint"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pint',
    templateUrl: './icon-pint.component.html',
    styleUrls: ['./icon-pint.component.scss'],
    standalone: false
})
export class IconPintComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
